// extracted by mini-css-extract-plugin
export default {"root":"ItemTip__root--2u2Ze","pinTooltip":"ItemTip__pinTooltip--3mHmG"};